import React from 'react';

import Router from './AppRouter';

import './App.css';
import './i18n';

const App = () => {
  return (
    <div style={{ overflow: 'hidden', height: '100vh' }}>
      <Router />
    </div>
  );
};

export default App;
